import React from "react";
import { ClipboardCheck, Key, MessageSquare, UserPlus, CreditCard } from "lucide-react";
export const HowItWorks = () => {
  const steps = [{
    icon: <ClipboardCheck className="h-8 w-8" data-id="element-49" />,
    title: "Quick Sign Up",
    description: "No long forms or interviews. Just tell us what industries you're into."
  }, {
    icon: <Key className="h-8 w-8" data-id="element-50" />,
    title: "Pick Your Brands",
    description: "Browse available companies and choose ones you actually like. No forced matches here."
  }, {
    icon: <MessageSquare className="h-8 w-8" data-id="element-51" />,
    title: "We Do The Work",
    description: "While you're out living your life, we're growing your network with relevant connections."
  }, {
    icon: <UserPlus className="h-8 w-8" data-id="element-52" />,
    title: "Network Grows",
    description: "Watch your LinkedIn network expand with people who share your professional interests."
  }, {
    icon: <CreditCard className="h-8 w-8" data-id="element-53" />,
    title: "Get That Money",
    description: "Start earning 150€ monthly, with opportunities to increase your earnings through higher engagement."
  }];
  return <section className="w-full bg-white py-16" data-id="element-54">
      <div className="max-w-4xl mx-auto px-4" data-id="element-55">
        <h2 className="text-3xl font-bold text-center mb-12" data-id="element-56">How It Works</h2>
        <div className="space-y-8" data-id="element-57">
          {steps.map((step, index) => <div key={index} className="flex items-start space-x-6" data-id="element-58">
              <div className="flex-shrink-0 w-12 h-12 rounded-full bg-emerald-100 flex items-center justify-center text-emerald-600" data-id="element-59">
                {step.icon}
              </div>
              <div data-id="element-60">
                <h3 className="text-xl font-semibold mb-2" data-id="element-61">{step.title}</h3>
                <p className="text-gray-600" data-id="element-62">{step.description}</p>
              </div>
            </div>)}
        </div>
      </div>
    </section>;
};